<template>

    <v-row dense>
        <v-col cols="12">
            <v-btn small text @click="delta = 0" color="blue">
                Set to now
            </v-btn>
        </v-col>

        <v-col cols="12">
            <v-text-field
                    solo flat outlined dense hide-details
                    :value="value.format()"
                    :disabled="true"
            >
            </v-text-field>
        </v-col>

        <v-col cols="4">
            <v-text-field
                    solo flat outlined dense hide-details
                    v-model="delta"
            >
            </v-text-field>
        </v-col>

        <v-col cols="8" class="">
            <v-select
                    solo flat outlined dense hide-details
                    v-model="unit"
                    :items="units"
            >
            </v-select>
        </v-col>

        <v-col cols="12" class="ml-1">
            <v-switch
                    solo flat outlined hide-details
                    inset
                    v-model="rounding"
                    :label="`Round to the ${unit}`"
            ></v-switch>
        </v-col>

    </v-row>

</template>

<script>
    import {mapActions} from "vuex";
    import {SEARCH_NS} from "@/store/modules/search/constants";
    import moment from "moment";

    export default {
        name: "DateTimeRelativeInput",
        props: ['value'],
        data() {
            return {
                units: [
                    {text: 'Minutes from now', value: 'minute'},
                    {text: 'Hours from now', value: 'hour'},
                    {text: 'Days from now', value: 'day'},
                    {text: 'Weeks from now', value: 'week'},
                    {text: 'Months from now', value: 'month'}
                ],
                unit: 'minute',
                rounding: false,
                delta: 10
            }
        },
        computed: {
            date() {
                let date = moment().subtract(this.delta, this.unit);
                date = this.rounding ? date.startOf(this.unit) : date;

                return date;
            }
        },
        watch: {
            date() {
                this.$emit('input', this.date);
            }
        },
        methods: {
            ...mapActions(SEARCH_NS, [
                'toggleDateTimePanel',
                'updatePeriod'
            ]),
            moment
        }
    }
</script>